/**
 * The Finance header's three figures — income, expense, net — for one stats block.
 *
 * User-testing hotfix (2026-10-06): a shared book's header was reported as
 * "Net balance +0,00 €" directly above "0,00 € − 16.500,00 €". The net used to
 * be read from the payload's own `net` field, independently of the two figures
 * printed beneath it, so ANY path that refreshed the totals without the net
 * (or vice versa) could show a balance that contradicts its own breakdown.
 * The net is now DERIVED from the two figures it sits above, so the card is
 * internally consistent by construction: what you read is always
 * income − expense of the numbers on screen.
 */
const toNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};
const cents = (n) => Math.round(n * 100) / 100;

export function bookTotals(raw, fallbackCurrency) {
    const expense = toNumber(raw?.expense_total ?? raw?.total_amount ?? 0);
    const income = toNumber(raw?.income_total ?? 0);
    // `+ 0` folds a -0 into 0 so a zero balance never renders as "−0,00".
    const net = cents(income - expense) + 0;
    return {
        expense,
        income,
        net,
        currency: raw?.currency || fallbackCurrency,
        unconverted: raw?.unconverted_count || 0,
    };
}
